module.exports = __webpack_public_path__ + "static/media/prepaid_a0c.a0e7a7db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/prepaid_a0c.png
// module id = 736
// module chunks = 21